<template>
  <Error
    :type="error?.statusCode || 500"
    :text="t('common.resource_loading_failed')"
  />
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps({
  error: Object as () => NuxtError,
});
const { t } = useI18n();
</script>

<style lang="scss" scoped></style>
